<template>
	<div v-if="showScreen" class="guest-applicant-template">
		
		<div class="stepper theming tertiary-color">
			<div class="container-lg px-0">
				<div class="row">
					<div class="col-md-24">
						<div class="d-flex flex-row">

							<div class="stepper__steps flex-grow-1" v-for="(step, index) in steps" :key="index">

								<div v-if="index > 0" class="stepper__steps__line current d-none-">
									<hr>
								</div>

								<div class="stepper__steps__step" :class="'step-' + index">

									<button
										class="stepper__steps__step__icon"
										:class="index + ' ' + (((current + 1) == (index + 1)) ? 'hello- router-link-active' : 'bye-')">
										{{ index + 1 }}
									</button>

									<div class="stepper__steps__step__label">
										<p class="fw-bold">{{ step.label ? step.label : stepLabels[step.num - 1] }}</p>
									</div>

								</div>
								<div v-if="index < (steps.length - 1)" class="stepper__steps__line current">
									<hr>
								</div>
							</div>

						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="container-xl">
			<div class="row">
				<div class="col-24">
					<div class="template__page-title">
						<template v-if="!submittingApp">
							<h1>Applicant</h1>
						</template>
					</div>
				</div>
			</div>
		</div>

		<form @submit.prevent="onSubmit" novalidate>

			<template v-if="!showConfirmationPage && !submittingApp">
				<div class="container-xl template--vh">
					<div class="row">
						<div class="col-lg-8">
							<ProgramSummaryCard
								:program="vModels.program"
								:program-type="programType"
								:clickable="false"
							/>


							<div v-if="applicant && applicant.firstName" class="tffi-card tffi-card-secondary-card theming primary-color">
								<div class="tffi-card-secondary-card__left-area">
									<!-- <div class="tffi-card-secondary-card__left-area__status-indicator">
										<div class="status-accepted">
											<img src="../../../../../assets/img/icons/check-mark.svg" alt="">
										</div>
										<div class="status-denied">
											<img src="../../../../../assets/img/icons/stop.svg" alt="">
										</div>
									</div> -->
								</div>
								<div class="tffi-card-secondary-card__right-area">
									<div class="tffi-card-secondary-card__right-area__title-area">
										<h2>Applicant</h2>
									</div>
									<div class="tffi-card-secondary-card__right-area__content-area">
										<p>{{ this.applicant['firstName'] + ' ' + this.applicant['lastName'] }}</p>
										<p>{{ this.applicant['email'] }}</p>
									</div>
									<!-- <button @click="removeApplicant(index)" class="tffi-card-secondary-card__right-area__trash-area">
										<img src="../../../../../assets/img/icons/garbage-can.svg" alt="">
									</button> -->
								</div>
							</div>
						</div>
						<div class="col-lg-16">

							<div class="tffi-card tffi-card-main-card">
								<div class="row">
									<div class="col-24">
										<h2>{{ this.vModels.firstName + ' ' + (this.vModels.middleInitial ?? '') + ' ' + this.vModels.lastName }}</h2>
									</div>
								</div>
								<div class="row row-cols-lg-3">
									<template v-for="(fieldData, fieldName) in getForm('2')">
										<div :class="fieldData.class">
											<div class="d-flex flex-column-">

												<form-field
													v-bind="checkForOptions(fieldName, fieldData)"
													v-model="vModels[fieldName]"
													:name="fieldName"
													:label="getLabel(fieldName)"
													:locale="locale"
													:options="(options[fieldName]) ? options[fieldName] : fieldData.options"
													bootstrap
													@change="onChange"
												></form-field>
											</div>
										</div>
									</template>
								</div>
								<div class="row row-cols-lg-2">

									<template v-for="(fieldData, fieldName) in getForm('2.0')">
										<div :class="fieldData.class">
											<div class="d-flex flex-column">

												<form-field
													v-bind="checkForOptions(fieldName, fieldData)"
													v-model="vModels[fieldName]"
													:name="fieldName"
													:label="getLabel(fieldName)"
													:locale="locale"
													:options="(options[fieldName]) ? options[fieldName] : fieldData.options"
													bootstrap
													@change="onChange"
												></form-field>
											</div>
										</div>
									</template>

									<template v-for="(fieldData, fieldName) in getForm('2.1')">

										<form-field 
											v-bind="checkForOptions(fieldName, fieldData)" 
											v-model="vModels[fieldName]" 
											:name="fieldName"
											:label="getLabel(fieldName)" 
											:options="(options[fieldName]) ? options[fieldName] : fieldData.options"
											:error="errors[fieldName]" 
											:locale="locale" 
											bootstrap 
											@change="onChange"
										></form-field>
									</template>

								</div>
							</div>

							<div class="container-fluid">
								<div class="row">
									<div class="col-24">
										<div class="template__secondary-title">
											<h2>Employer Details</h2>
										</div>
									</div>
								</div>
							</div>

							<div class="tffi-card tffi-card-main-card">
								<div class="row row-cols-md-2">
									<template v-for="(fieldData, fieldName) in getForm('2.2')">
										<div :class="fieldData.class">
											<div class="d-flex flex-column">
												<form-field 
													v-bind="checkForOptions(fieldName, fieldData)" 
													v-model="vModels[fieldName]" 
													:name="fieldName"
													:label="getLabel(fieldName)" 
													:options="(options[fieldName]) ? options[fieldName] : fieldData.options"
													:error="errors[fieldName]" 
													:locale="locale" 
													bootstrap 
													@change="onChange"
												></form-field>
											</div>
										</div>
									</template>
								</div>
							</div>

						</div>
					</div>
				</div>

				<div class="tffi-navigation-bottom mb-5">
					<div class="container-xl">
						<div class="row">
							<div class="col order-2 order-lg-1 col-24 col-lg-16 d-flex justify-content-start">
								<button
									type="button"
									class="d-none tffi-btn tffi-btn--solid theming secondary-color"
									color="primary"
									:loading="goingBack"
									@click="goBack({ name: 'ApplicationStep1', params: $route.params })"
								>
									{{ $t('forms.back') }}
								</button>
							</div>
							<div class="col order-1 order-lg-2 col-24 col-lg-8 d-flex justify-content-end">
								<button
									class="tffi-btn tffi-btn--solid theming primary-color me-0"
									:loading="goingBack"
									@click="goToSummary"
									
									>
									Next
								</button>
							</div>
						</div>
					</div>
				</div>
			</template>

			<template v-if="showConfirmationPage && !submittingApp">
				<div class="container-xl template--vh">
					<div class="row">
						<div class="col-lg-8">
						<ProgramSummaryCard
							:program="vModels.program"
							:program-type="programType"
							:clickable="false"
						/>
					</div>
						<div class="col-lg-16">

							<div class="tffi-card tffi-card-review-card mb-5">
								<div class="tffi-card-review-card__review-list__header theming primary-color">
									<p class="theming primary-color">Applicant</p>
									<span class="flex-grow-1"></span>
								</div>
								<ul class="tffi-card-review-card__review-list list-unstyled w-100">
									<template v-for="(fieldData, fieldName) in getForm('2')">

										<li>
											<label>{{ $t('newApplication.' + fieldName) }}:</label>
											<span class="flex-grow-1"></span>
											<p class="tffi-card-review-card__review-list__detail">{{ displayUpper(vModels[fieldName]) }}</p>
											<div v-if="getFieldError(fieldName)" class="invalid-feedback">{{ getFieldError(fieldName) }}</div>
										</li>

									</template>

									<template v-for="(fieldData, fieldName) in getForm('2.0')">

										<li>
											<label>{{ $t('newApplication.' + fieldName) }}:</label>
											<span class="flex-grow-1"></span>
											<p class="tffi-card-review-card__review-list__detail">{{ displayUpper(vModels[fieldName]) }}</p>
											<div v-if="getFieldError(fieldName)" class="invalid-feedback">{{ getFieldError(fieldName) }}</div>
										</li>

									</template>
								</ul>

								<div class="tffi-card-review-card__review-list__header theming primary-color">
									<p class="theming primary-color">Address</p>
									<span class="flex-grow-1"></span>
								</div>
								<ul class="tffi-card-review-card__review-list list-unstyled w-100">

									<template v-for="(fieldData, fieldName) in getForm('2.1')">

										<li>
											<label>{{ $t('newApplication.' + fieldName) }}:</label>
											<span class="flex-grow-1"></span>
											<p class="tffi-card-review-card__review-list__detail">{{ displayUpper(vModels[fieldName]) }}</p>
											<div v-if="getFieldError(fieldName)" class="invalid-feedback">{{ getFieldError(fieldName) }}</div>

										</li>

									</template>
								</ul>

								<div class="tffi-card-review-card__review-list__header theming primary-color">
									<p class="theming primary-color">Employer Details</p>
									<span class="flex-grow-1"></span>
								</div>
								<ul class="tffi-card-review-card__review-list list-unstyled w-100 my-0">
									<template v-for="(fieldData, fieldName) in getForm('2.2')">

										<li>
											<label>{{ $t('newApplication.' + fieldName) }}:</label>
											<span class="flex-grow-1"></span>
											<p class="tffi-card-review-card__review-list__detail">{{ displayUpper(vModels[fieldName]) }}</p>
											<div v-if="getFieldError(fieldName)" class="invalid-feedback">{{ getFieldError(fieldName) }}</div>

										</li>

									</template>
								</ul>
							</div>

							<div class="container-fluid">
								<div class="row">
									<div class="col-24">
										<div class="template__secondary-title">
											<h2>Terms & Conditions</h2>
											<div class="d-flex align-items-center-">
												<input v-bind="acceptTerms" v-model="vModels['acceptTerms']" type="checkbox"
												name="terms-and-conditions-checkbox" id="terms-and-conditions-checkbox"
												class="tffi-input-checkbox theming primary-color mb-0 me-3">
												<label for="terms-and-conditions-checkbox">
													I agree, acknowledge and represent, that by personally submitting this application TwentyFirst Financial Inc. and/or its affiliates is authorized to obtain my credit report from one or more consumer credit reporting agencies, to verify the information in my credit report with third parties as necessary, and to periodically update my credit information with credit reporting agencies. In addition, I consent to accept, receive, and use in electronic form any loan agreement (and any amendments or renewals), disclosure statements, notices or other associated documents and/ or information that may be delivered to me.
												</label>
											</div>
										</div>
									</div>
								</div>
							</div>

						</div>
					</div>
				</div>

				<div class="tffi-navigation-bottom mb-5">
					<div class="container-xl">
						<div class="row">
							<div class="col order-2 order-lg-1 col-24 col-lg-16 d-flex justify-content-start">
								<button
									type="button"
									class="tffi-btn tffi-btn--solid theming secondary-color"
									color="primary"
									:loading="goingBack"
									@click="showConfirmationPage = false; current = 0"
								>
									{{ $t('forms.back') }}
								</button>
							</div>
							<div class="col order-1 order-lg-2 col-24 col-lg-8 d-flex justify-content-end">
								<button
									class="tffi-btn tffi-btn--solid theming primary-color me-0"
									:loading="goingBack"
									@click="submitApp"
									>
									Submit
								</button>
							</div>
						</div>
					</div>
				</div>
			</template>

			<template v-if="submittingApp">
				<div class="container-md">
					<div class="row">
						<div class="col-24">
							<h2 class="fw-bold text-dark mb-4">
								Thank you! Submission Complete
							</h2>

							<p>
								Your submission has been received and is under review.  If there are any questions, you may be asked to provide additional details.
							</p>
						</div>
					</div>
				</div>
			</template>
		</form>

	</div>
</template>

<script>

// import { mapState } from 'vuex';
import ApplicationMixin from './../../application/components/ApplicationForms/Application/ApplicationMixin.js';
import { getApplication, saveApplication } from '../../api';
import FormsConfirmationMixin from './../../application/components/ApplicationForms/FormsConfirmationMixin.js';
import { mapActions, mapState } from 'vuex';
import { isNumber } from '@incodeapps/js-utilities';
import ProgramSummaryCard from '../../elements/components/ProgramSummaryCard';


export default {
	components: {
		ProgramSummaryCard
	},
	mixins: [
		ApplicationMixin,
		FormsConfirmationMixin
	],

	filters: {
		formatMoney(value) {
			return new Intl.NumberFormat('en-US', {minimumFractionDigits: 2,}).format(value);
		},
	},

	data() {

		return {
			showScreen: false,
			showConfirmationPage: false,
			submittingApp: false,
			applicant: {},
			coApps: [],
			programType: '',

			steps: [{
				num: 1,
				name: 'Applicant',
				label: 'Applicant',
			}, {
				num: 2,
				name: 'Review and Submit',
				label: 'Review and Submit',
			}],
			current: 0,
			total: 2,

		selectedApp: {},
		selectedAppIndex: 'main',
		app: null,
		acceptTerms: false,
		canadaPostScriptsLoaded: false,
		canadaPostControl: null,
			vModels: {
				id: '',
				acceptTerms: '',
				firstName: '',
				middleInitial: '',
				lastName: '',
				sin: '',
				dob: '',
				primaryPhone: '',
				mobilePhone: '',
				country: 'Canada',
				address1: '',
				address2: '',
				province: '',
				city: '',
				postal: '',
				titleOwner: ' ',
				grossIncome: '',
				totalHousingCosts: '',
				totalOtherMonthlyCosts: '',
				program: {}
			},
			required: [
				'dob',
				'primaryPhone',
				'address1',
				'province',
				'city',
				'postal',
				'titleOwner',
				'employer',
				'employmentTitle',
				'grossIncome',
				'employmentTerm'
			]
		};

	},

	watch: {
		'vModels.province': function(newProvince, oldProvince) {
			console.log("changed!!!!!!!!!!!!!!", newProvince);
            if (newProvince && oldProvince !== undefined && newProvince !== oldProvince) {
                this.updateLeaseTaxesInBackground(newProvince);
            }
        }
	},

	created() {

	},

	async mounted() {

		this.saveLoading(true);

		let id = this.$route.params.applicationId
		let token = this.$route.query.token

		let errorMsg = 'Error';

		let res = await getApplication(id, token).catch(async err => {

			if (err.response && err.response.data && err.response.data.errorMessage) {

				if (err.response.data.errorMessage == 'Invalid token') {
					errorMsg = 'Token expired. Request a new invite from dealer.';
				} else {
					errorMsg = err.response.data.errorMessage;
				}

			} else if (err.message && err.message !== 'Network Error') {

				errorMsg = err.message;

			}

			this.errorAlert = await this.showErrorAlert(errorMsg);

			this.showScreen = false;

			this.saveLoading(false)

		});

		if (!res) {
			return;
		}

		this.app = res

		if (this.app !== undefined) {
			this.showScreen = true;
		}

		this.applicant = {
			firstName: this.app.firstName,
			middleInitial: this.app.middleInitial,
			lastName: this.app.lastName,
			email: this.app.email
		}

		this.coApps = this.app.coApps

		this.vModels = this.app

		this.vModels.program = this.app.program

		this.programType = this.vModels.program.program.Code == 2 ? 'Lease' : 'Loan'

		if (
			this.app
			&& this.app.meta
			&& this.app.meta.color1
		) {

			const rootElement = document.documentElement;

			this.app.meta.color1 ? rootElement.style.setProperty('--tffi-primary-color', this.app.meta.color1) : '';
			this.app.meta.color2 ? rootElement.style.setProperty('--tffi-secondary-color', this.app.meta.color2) : '';
			this.app.meta.color3 ? rootElement.style.setProperty('--tffi-tertiary-color', this.app.meta.color3) : '';
			this.app.meta.color4 ? rootElement.style.setProperty('--tffi-accent-color', this.app.meta.color4) : '';
		}

		// Load Canada Post scripts after data is loaded and screen is shown
		this.$nextTick(() => {
			this.loadCanadaPostScripts();
		});

		this.saveLoading(false);

	},

	methods: {

		...mapActions([
			'throwFatalError',
			'submitApplicationAction',
			// 'saveApplicationAction',
			// 'saveValidateAll'
		]),

		async updateLeaseTaxesInBackground(newProvince) {
            const outerProgram = this.vModels.program;

            if (!outerProgram || !outerProgram.payment) {
                console.log("Aborted: Missing payment variable on outer program.");
                return;
            }

            // Define the provincial tax rates
            const PROVINCIAL_TAX_RATES = {
                "AB": 0.05, "BC": 0.12, "MB": 0.12, "NB": 0.15, "NL": 0.15,
                "NT": 0.05, "NS": 0.14, "NU": 0.05, "ON": 0.13, "PE": 0.15,
                "QC": 0.14975, "SK": 0.11, "YT": 0.05
            };
            
            const newTaxRate = PROVINCIAL_TAX_RATES[newProvince] || 0.13;

            const paymentForMath = Number(outerProgram.payment);
            const totalPayments = Number(outerProgram.totalPayments);

            const salesTax = newTaxRate * paymentForMath;
            const paymentWithTax = paymentForMath + salesTax;
            const totalPaymentsWithTax = totalPayments * (1 + newTaxRate);

            const updatedProgram = {
                ...outerProgram,
                taxRate: Number(newTaxRate.toFixed(4)),
                salesTax: salesTax,
                paymentWithTax: paymentWithTax,
                totalPaymentsWithTax: totalPaymentsWithTax,
                initialPaymentWithTax: paymentWithTax 
            };

            if (updatedProgram.program) {
                updatedProgram.program = {
                    ...updatedProgram.program,
                    taxRate: Number(newTaxRate.toFixed(4))
                };
            }

            this.$set(this.vModels, 'program', updatedProgram);
            
            console.log("Successfully calculated new taxes for:", newProvince, "Rate:", newTaxRate);
        },

		loadCanadaPostScripts() {
			// Check if address lookup limit has been reached
			const storageKey = 'canadaPostAddressLookupCount';
			const maxLookups = 10;
			let lookupCount = parseInt(localStorage.getItem(storageKey) || '0', 10);

			if (lookupCount >= maxLookups) {
				console.log(`Canada Post address lookup limit reached (${maxLookups}). Script will not be loaded.`);
				return;
			}

			let apiKey = 'EE66-UA95-ZH46-FA97';

			// Destroy existing control if it exists
			if (this.canadaPostControl) {
				this.canadaPostControl.destroy();
				this.canadaPostControl = null;
			}

			// Only load scripts once
			if (!this.canadaPostScriptsLoaded) {
				let addressCompleteScript = document.createElement('script');
				let addressCompleteCSS = document.createElement('link');

				addressCompleteCSS.setAttribute('rel', 'stylesheet');
				addressCompleteCSS.setAttribute('type', 'text/css');
				addressCompleteCSS.setAttribute('href', `https://ws1.postescanada-canadapost.ca/css/addresscomplete-2.30.min.css?key=${apiKey}`);

				document.head.appendChild(addressCompleteCSS);

				addressCompleteScript.setAttribute('src', `https://ws1.postescanada-canadapost.ca/js/addresscomplete-2.30.min.js?key=${apiKey}&culture=en`);

				addressCompleteScript.onload = () => {
					let fields = [
						{ element: "address1", field: "Line1", mode: pca.fieldMode.DEFAULT },
						{ element: "address2", field: "Line2", mode: pca.fieldMode.POPULATE },
						{ element: "city", field: "City", mode: pca.fieldMode.POPULATE },
						{ element: "province", field: "ProvinceName", mode: pca.fieldMode.POPULATE },
						{ element: "postal", field: "PostalCode", mode: pca.fieldMode.POPULATE },
					];
					let options = {
						key: apiKey
					};
					this.canadaPostControl = new pca.Address(fields, options);
					this.canadaPostControl.listen('populate', (address) => {
						// Increment lookup count and store in localStorage
						const storageKey = 'canadaPostAddressLookupCount';
						const maxLookups = 10;
						let currentCount = parseInt(localStorage.getItem(storageKey) || '0', 10);
						currentCount++;
						localStorage.setItem(storageKey, currentCount.toString());
						
						// If limit reached, destroy the control
						if (currentCount >= maxLookups) {
							console.log(`Address lookup limit reached (${maxLookups}). Destroying Canada Post control.`);
							if (this.canadaPostControl) {
								this.canadaPostControl.destroy();
								this.canadaPostControl = null;
							}
							return;
						}

						// GuestApplication only has one applicant, always use vModels
						const model = this.vModels;
						if (!model) {
							console.error('vModels is not defined');
							return;
						}
						model.address1 = address.Line1;
						model.address2 = address.Line2 || '';
						model.city = address.City;
						model.postal = address.PostalCode;

						const provinceName = address.ProvinceName;

						// Try to match province name from form configuration
						const addressForm = this.getForm('2.1');
						if (addressForm && addressForm.province && addressForm.province.options) {
							const provinceEntry = Object.entries(addressForm.province.options).find(([_key, value]) => {
								return value.en === provinceName
							});
							if (provinceEntry && provinceEntry[0]) {
								const provinceValue = provinceEntry[0];
								// Use $set to ensure Vue reactivity
								this.$set(model, 'province', provinceValue);
								// Sync the DOM select element and trigger change event
								this.$nextTick(() => {
									if (this.manuallySetSelectValue) {
										this.manuallySetSelectValue('province', provinceValue);
									}
								});
							} else {
								this.$set(model, 'province', '');
							}
						}
					});
				};

				document.head.appendChild(addressCompleteScript);
				this.canadaPostScriptsLoaded = true;
			} else {
				// Scripts already loaded, create control immediately
				let fields = [
					{ element: "address1", field: "Line1", mode: pca.fieldMode.DEFAULT },
					{ element: "address2", field: "Line2", mode: pca.fieldMode.POPULATE },
					{ element: "city", field: "City", mode: pca.fieldMode.POPULATE },
					{ element: "province", field: "ProvinceName", mode: pca.fieldMode.POPULATE },
					{ element: "postal", field: "PostalCode", mode: pca.fieldMode.POPULATE },
				];
				let options = {
					key: apiKey
				};
				this.canadaPostControl = new pca.Address(fields, options);
				this.canadaPostControl.listen('populate', (address) => {
					// Increment lookup count and store in localStorage
					const storageKey = 'canadaPostAddressLookupCount';
					const maxLookups = 10;
					let currentCount = parseInt(localStorage.getItem(storageKey) || '0', 10);
					currentCount++;
					console.log("currentCount ==> ", currentCount);
					localStorage.setItem(storageKey, currentCount.toString());
					
					// If limit reached, destroy the control
					if (currentCount >= maxLookups) {
						console.log(`Address lookup limit reached (${maxLookups}). Destroying Canada Post control.`);
						if (this.canadaPostControl) {
							this.canadaPostControl.destroy();
							this.canadaPostControl = null;
						}
						return;
					}

					// GuestApplication only has one applicant, always use vModels
					const model = this.vModels;
					if (!model) {
						console.error('vModels is not defined');
						return;
					}
					model.address1 = address.Line1;
					model.address2 = address.Line2 || '';
					model.city = address.City;
					model.postal = address.PostalCode;

					const provinceName = address.ProvinceName;

					// Try to match province name from form configuration
					const addressForm = this.getForm('2.1');
					if (addressForm && addressForm.province && addressForm.province.options) {
						const provinceEntry = Object.entries(addressForm.province.options).find(([_key, value]) => {
							return value.en === provinceName
						});
						if (provinceEntry && provinceEntry[0]) {
							const provinceValue = provinceEntry[0];
							// Use $set to ensure Vue reactivity
							this.$set(model, 'province', provinceValue);
							// Sync the DOM select element and trigger change event
							this.$nextTick(() => {
								if (this.manuallySetSelectValue) {
									this.manuallySetSelectValue('province', provinceValue);
								}
							});
						} else {
							this.$set(model, 'province', '');
						}
					}
				});
			}

		},

		getFieldError(name) {

			// return this.application.errors && this.application.errors[name];

		},

		async goToSummary() {

			// this.saveValidateAll(true);
			console.log('this.application.errors', this.application.errors);
			console.log('this.errors', this.errors);
			// return;

			this.saveLoading(true);

			// console.log('errors', this.errors);

			// await this.saveApp()

			// if (Object.keys(this.errors).length == 0) {

			// }

			let notFilled = []
			this.required.forEach(element => {

				let fieldValue = this.vModels[element];
				
				// For select fields, also check the DOM value as fallback
				// This handles cases where Canada Post autocomplete sets the DOM value
				// but Vue's model might not be synced yet
				if (
					fieldValue == ''
					|| fieldValue == ' '
					|| fieldValue == '-'
					|| fieldValue == undefined
					|| fieldValue == null
				) {
					// Check if it's a select field and get value from DOM
					const selectElement = document.querySelector(`select[name="${element}"]`);
					if (selectElement && selectElement.value && selectElement.value !== '' && selectElement.value !== '-' && selectElement.value !== ' ') {
						// DOM has a value, sync it to the model
						fieldValue = selectElement.value;
						this.$set(this.vModels, element, fieldValue);
					}
				}
				
				console.log(element, fieldValue);
				if (
					fieldValue == ''
					|| fieldValue == ' '
					|| fieldValue == '-'
					|| fieldValue == undefined
					|| fieldValue == null
				) {
					notFilled.push(element)
				}

			});

			console.log('notFilled', notFilled);

			if (notFilled.length > 0) {

				let notFilledProper = ''
				notFilled.forEach(element => {
					notFilledProper += this.$i18n.t('newApplication.' + element) + ', '
				});

				await this.showErrorAlert('Please fill in the following required fields: ' + notFilledProper)

				this.saveLoading(false);
				return
			}


			if (
				this.vModels.dob
				&& this.vModels.dob != ''
			) {
				if (!await this.isDobValid(this.vModels.dob)) {
					this.saveLoading(false)
					this.showErrorAlert('Use format mm/dd/yyyy for Date of Birth. Applicants must be between 18 and 100 years of age.')
					return false
				}
			}

			if (
				this.vModels.employmentTerm
				&& this.vModels.employmentTerm != ''
			) {
				if (
					!await this.isEmploymentTermValid(this.vModels.employmentTerm)
				) {
					this.saveLoading(false)
					this.showErrorAlert('Employment should be less than 70 years. Use format mm/dd/yyyy for Employment Since.')
					return false
				}
			}

			if (
				this.vModels.grossIncome
				&& this.vModels.grossIncome != ''
			) {
				if (
					this.vModels.grossIncome < 10000
				) {
					this.saveLoading(false)
					this.showErrorAlert('Gross Income should be more than $10,000.')
					return false
				}
			}


			this.showConfirmationPage = true
			this.current = 1


			this.saveLoading(false);

		},

		async submitApp() {

			this.saveLoading(true);

			this.showConfirmationPage = true;

			console.log('this.vModels.acceptTerms', this.vModels.acceptTerms);

			if (
				this.vModels.acceptTerms === false
				|| this.vModels.acceptTerms=== undefined
				// || this.vModels.acceptTerms === false
			) {

				this.saveLoading(false);

				await this.showErrorAlert('Please check accept terms checkbox');

				return;

			}
			
			await this.saveApp()

			this.submittingApp = true;

			this.saveLoading(false);

		},

		async saveApp() {

			let id = this.$route.params.applicationId
			this.vModels.id = id

			let application = await saveApplication(this.vModels).catch(err => {

				if (err.response && err.response.data && err.response.data.errorMessage) {

					// dispatch('showErrorAlert', err.response.data.errorMessage);

				} else if (err.message && err.message !== 'Network Error') {

					// dispatch('showErrorAlert', err.message);

				}

			});

		},

		onSubmit(e) {

			this.isLoading = true;
			this.submitting = true;

			console.debug(
				'[onSubmit] event:', e,
				'\nvModels:', JSON.stringify(this.vModels, null, 2)
			);

		},

		displayUpper(value) {
			if (value === undefined || value === null || value === '') {
				return '—';
			}
			return String(value).toUpperCase();
		}
	}

};

</script>

<style lang="scss" scoped>
.float-right {
	float: right;
}
</style>
